import React from "react";
import ModelFront1 from "../../resources/model_front.jpg";
import ModelBack1 from "../../resources/model_back.jpg";
import ModelApp from "../../resources/model_app.png";

const Model = () => {
    return (
    <div className="page__section" id="model">
        <p className="title">Il Modello</p>
        <hr></hr>
        <div className='model__content'>
        <img className='model__image model__image__front' src={ModelFront1}></img>
        <img className='model__image model__image__back' src={ModelBack1}></img>
        <img className='model__image model__image__app' src={ModelApp}></img>
        </div>
    </div>
    );
};


export default Model;